import { LOGIN_SERVICES } from "@repositories/login/login.hooks";
import router from "next/router";

async function getGenerateToken() {
  try {
    const { data } = await LOGIN_SERVICES.POST_GENERATE_TOKEN();
    const { accessToken } = data;
    return accessToken;
  } catch {
    router.push("/");
  }
}

export default getGenerateToken;
